import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

const selectDomain = (state) => state.raisedCorrection || initialState;

export const selectCorrectionData = createSelector(
  [selectDomain],
  (state) => state.CorrectionData
);


